<div class="tw-mt-10 tw-rounded-10px tw-border tw-border-divider tw-p-5 tw-text-center lg:tw-p-10">
  <div class="-tw-mt-20">
    <img
      class="logo-image tw-mb-4"
      [alt]="campaign.company?.brandName"
      [src]="campaign.company?.companyLogoUrl || defaultLogo"
    />

    <span class="p-text-h2 tw-mb-5 tw-block tw-text-black">
      {{ campaign.company?.brandName }}
    </span>

    <!-- Company Name -->
    @if (campaign.company?.name) {
      <p class="tw-font-semibold tw-text-black tw-opacity-95">
        {{ campaign.company?.name }}
      </p>
    }

    <!-- Address -->
    <p>{{ campaign.company?.address || '-' }}</p>

    <!-- Registration Number (optional) -->
    @if (campaign.company?.registrationNumber) {
      <p class="tw-opacity-75">Reg No: {{ campaign.company?.registrationNumber }}</p>
    }

    <!-- Website Url (optional) -->
    @if (campaign.company?.websiteUrl) {
      <p>
        <a
          class="tw-font-bold tw-underline"
          [href]="campaign.company?.websiteUrl | weblink"
          target="_blank"
        >
          {{ campaign.company?.websiteUrl | weblink: 'true' }}
        </a>
      </p>
    }

    <!-- Social Links (optional) -->
    @if (campaign.company?.socialLinks.length > 0) {
      <div class="tw-flex tw-justify-center tw-gap-2.5">
        @for (social of campaign.company?.socialLinks; track social) {
          @if (social.url) {
            <a [href]="social.url | weblink" target="_blank">
              <div
                class="tw-h-8 tw-w-8"
                [class.pitchin-icon-facebook]="social.type == SocialLinkType.Facebook"
                [class.pitchin-icon-twitter]="social.type == SocialLinkType.Twitter"
                [class.pitchin-icon-instagram]="social.type == SocialLinkType.Instagram"
                [class.pitchin-icon-linkedin]="social.type == SocialLinkType.LinkedIn"
                [class.pitchin-icon-tiktok]="social.type == SocialLinkType.TikTok"
              ></div>
            </a>
          }
        }
      </div>
    }
  </div>
</div>
